<div fxLayout="column" fxLayout.lt-md="column">
  <p fxFlex="100" class="sec-title"> {{title}} </p>
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
    <ng-content></ng-content>
  </div>
</div>
